import CustomElement from '~utilities/custom-element';
import 'custom-event-polyfill';
import 'url-polyfill';
import Plyr from 'plyr';

class CustomPlayer extends CustomElement {
    constructor() {
        super();

        const url = this.dataset.url;
        this.data = this.parseUrl(url);
    }

    template() {
        return `
            <div class="c-custom-player ${this.className ? this.className : ''}" js-custom-player>
                <div class="custom-player__embed" data-plyr-provider="${this.data.provider}" data-plyr-embed-id="${this.data.id}" js-custom-player-embed="${this.data.id}"></div>
            </div>
        `;
    }

    parseUrl(url) {
    
        url.match(/(http:\/\/|https:\/\/|)(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/);
        const provider = (RegExp.$3.indexOf('youtu') > -1) ? 'youtube' : 'vimeo';
    
        return {
            provider: provider,
            id: RegExp.$6,
            url: url
        };
    }

    callback() {
        super.callback();

        this.player = new Plyr(`[js-custom-player-embed="${this.data.id}"]`);
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if(newValue === 'play') this.player.play();
        if(newValue === 'stop') this.player.stop();
    }
}

export default CustomPlayer;

